import flatpickr from "flatpickr";
import "flatpickr/dist/themes/dark.css";

export default function init() {
  const startDateDisable = [
    function (date) {
      // Disable dates in the past, but allow today
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const current = new Date(date);
      current.setHours(0, 0, 0, 0);
      return current < today;
    }
  ];
  const endDateDisable = [
    function (date) {
      // Disable dates in the past
      return date < new Date();
    },
  ];
  flatpickr("#start-date-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: startDateDisable,
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-start-date").value =
          selectedDates[0].toISOString();
      }
      endDateDesktop.redraw(); // Redraw to update the end date picker
    },
  });
  const endDateDesktop = flatpickr("#end-date-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before or same to start date
        const startDate = document.getElementById("start-date-input").value; // Y-m-d
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-end-date").value =
          selectedDates[0].toISOString();
      }
    },
  });

  flatpickr("#contact-us-input", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d H:i",
    disableMobile: true,
  });
  flatpickr("#arrival", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d",
    disableMobile: true,
  });
  flatpickr("#depature", {
    altInput: true,
    enableTime: true,
    dateFormat: "Y-m-d",
    disableMobile: true,
  });
  flatpickr("#mobile-start-date-search-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before the start date
        const startDate = document.getElementById("start-date-input").value;
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-end-date").value =
          selectedDates[0].toISOString();
      }
      endDateMobile.redraw(); // Redraw to update the end date picker
    },
  });
  const endDateMobile = flatpickr("#mobile-end-date-search-input", {
    altInput: true,
    altFormat: "m/d/y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before the start date
        const startDate = document.getElementById("mobile-start-date-search-input").value;
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0 && document.getElementById("formatted-start-date")) {
        document.getElementById("formatted-start-date").value =
          selectedDates[0].toISOString();
      }
    },
  });

  flatpickr("#start-date-search-input", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: startDateDisable,
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-start-date").value =
          selectedDates[0].toISOString();
      }
      endDateSearch.redraw(); // Redraw to update the end date picker
    },
  });
  const endDateSearch = flatpickr("#end-date-search-input", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    disable: endDateDisable.concat([
      function (date) {
        // Disable dates before or same to start date
        const startDate = document.getElementById("start-date-search-input").value; // Y-m-d
        if (startDate) {
          // Compare only the date parts (ignore time)
          // Parse startDate in "Y-m-d" format safely
          const [year, month, day] = startDate.split('-').map(Number);
          const start = new Date(year, month - 1, day);
          start.setHours(0, 0, 0, 0);
          const current = new Date(date);
          current.setHours(0, 0, 0, 0);
          return current < start || current.getTime() === start.getTime();
        }
        return false; // Allow all dates if no start date is selected
      },
    ]),
    onChange: function (selectedDates, dateStr, instance) {
      if (selectedDates.length > 0) {
        document.getElementById("formatted-end-date").value =
          selectedDates[0].toISOString();
      }
    },
  });

  
  const page = window.location.pathname.split("/").pop();
  $("#desktop-search-form, #filters-search-form").on("submit", function (e) {
    e.preventDefault(); // Prevent the form from submitting normally

    // Serialize form data
    // Remove empty inputs before serializing
    $(this)
      .find("input, select, textarea")
      .filter(function () {
        return !this.value || this.value.trim() === "";
      })
      .prop("disabled", true);

    var formData = $(this).serialize();

    // Re-enable the inputs after serialization
    $(this).find("input, select, textarea").prop("disabled", false);
    // for checkboxes, we need to convert the values to an array
    formData = formData.replace(/category=([^&]*)/g, function (match, p1) {
      // if the value is not an array, we need to convert it to an array
      if (!Array.isArray(p1)) {
        // replace the spaces by dashes
        p1 = decodeURIComponent(p1).replace(/\s+/g, "-");
        return "category[]=" + encodeURIComponent(p1);
      }
      return match; // if it's already an array, return the original match
    });
    // also timeRange is a checkbox, so we need to convert it to an array
    formData = formData.replace(/timeRange=([^&]*)/g, function (match, p1) {
      // if the value is not an array, we need to convert it to an array
      if (!Array.isArray(p1)) {
        return "timeRange[]=" + encodeURIComponent(p1);
      }
      return match; // if it's already an array, return the original match
    });
    if (['shows', 'attractions', 'tours'].includes(page)) {
      //check if we don't have any category selected
      const categories = formData.match(/category\[\]=([^&]*)/g) || [];
      if (categories.length === 0) {
        // by default for shows
        let categories = [
          'adult-shows', 
          'comedy-shows', 
          'magic-shows', 
          'musical-shows', 
          'production-shows', 
          'tribute-shows',
        ];
        if (page === 'attractions') {
          categories = [
            'attractions',
            'concerts',
            'nightlife',
            'pop'
          ];
        } else if (page === 'tours') {
          categories = [
            'tours',
          ];
        }
        // add to the categories to the formData
        categories.forEach(category => {
          formData += `&category[]=${encodeURIComponent(category)}`;
        });
      }
    }
    // Set the serialized data in the URL
    const newUrl = window.location.origin + "/search" + "?" + formData;
    window.location.href = decodeURI(newUrl);
  });

  // now set the input values from the URL
  const urlParams = new URLSearchParams(window.location.search);
  // using the name of params in the URL, we can set the values of the inputs
  $("#desktop-search-form input, #filters-search-form input").each(function () {
    let name = $(this).attr("name");
    // category and timeRange are arrays, so add '[]' to the name
    if (name === "category" || name === "timeRange") {
      name += "[]";
    }
    if (urlParams.has(name)) {
      const values = urlParams.getAll(name).map(decodeURIComponent);
      if ($(this).is(":checkbox")) {
        // For checkboxes, check if the value matches any of the URL param values
        // for cagegories we need to replace dashes by spaces
        if (name === "category[]") {
          const formattedValues = values.map(value => value.replace(/-/g, " "));
          $(this).prop("checked", formattedValues.includes($(this).val()));
        } else {
          $(this).prop("checked", values.includes());
        }
      } else {
        if (name === "startDate" || name === "endDate") {
          $(this).val(moment(values[0]).format("YYYY-MM-DD"));
        } else {
          $(this).val(values[0]);
        }
      }
    }
  });

  $("#clear-filters-button").on("click", function () {
    $("#desktop-search-form, #filters-search-form").trigger("reset");
  });

  $(".search-tag-container").on("click", function (e) {
    try {
      var categoryName = $(e.currentTarget).text().toLowerCase().trim();
      var input = $(
        `input[type="checkbox"][name="category"][value="${categoryName.trim()}"]`
      ).first();
      input.prop("checked", true);
      document.getElementById("filters-search-form").submit();
    } catch (error) {
      console.log(error);
    }
  });

  $("#section-sort-search > select").change(function () {
    var selectedValue = $(this).val();
    var url = new URL(window.location.href);
    // when val is sequence, remove the sort parameter from the URL
    if (selectedValue === "sequence") {
      url.searchParams.delete("sort");
      url.searchParams.delete("sortDesc");
    }
    // when is price_l_h
    else if (selectedValue === "price_l_h") {
      url.searchParams.set("sort", "price_display");
      url.searchParams.set("sortDesc", "false");
    }
    // when is price_h_l
    else if (selectedValue === "price_h_l") {
      url.searchParams.set("sort", "price_display");
      url.searchParams.set("sortDesc", "true");
    }
    // when is name_a_z
    else if (selectedValue === "name_a_z") {
      url.searchParams.set("sort", "name");
      url.searchParams.set("sortDesc", "false");
    }
    // when is name_z_a
    else if (selectedValue === "name_z_a") {
      url.searchParams.set("sort", "name");
      url.searchParams.set("sortDesc", "true");
    }
    // now let's attached the new URL to the window location
    window.location.href = decodeURI(url.toString());
  });
  // when tha page load we need to set the value of the select
  const sortSelect = $("#section-sort-search > select");
  const sortValue = urlParams.get("sort");
  if (sortValue) {
    if (sortValue === "price_display") {
      var sortDesc = urlParams.get("sortDesc");
      if (sortDesc === "true") {
        sortSelect.val("price_h_l");
      } else {
        sortSelect.val("price_l_h");
      }
    } else if (sortValue === "name") {
      var sortDesc = urlParams.get("sortDesc");
      if (sortDesc === "true") {
        sortSelect.val("name_z_a");
      } else {
        sortSelect.val("name_a_z");
      }
    } else {
      sortSelect.val("sequence");
    }
  }
  // handle pagination
  handlePagination();
}

function handlePagination() {
  const defaultLimit = 8; // default limit for pagination
  // look for the limit in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const limit = Number(urlParams.get("pagination")) || defaultLimit;
  const shows = $(".deal-card-container.search-card");
  // just hide the rest of the shows after the limit
  shows.each(function (index) {
    if (index >= limit) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  // if not there are shows hide let's remove the pagination button
  const showsNotVisible = $(".deal-card-container.search-card:hidden");
  if (showsNotVisible.length === 0) {
    $("#show-more-search").hide();
  }
  // let's handle the show more button
  $("#show-more-search")
    .off("click")
    .on("click", function () {
      const currentVisibleCount = $(".deal-card-container.search-card:visible").length;
      const nextLimit = parseInt(currentVisibleCount) + defaultLimit;
      shows.each(function (index) {
          $(this).show();        
      });
      // update the URL with the new limit
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("pagination", nextLimit);
      window.history.pushState({}, "", decodeURI(newUrl.toString()));
      // if we have shown all the shows, hide the button
      if ($(".deal-card-container.search-card:visible").length === shows.length) {
        $(this).hide();
      }
    });
}
